<div class="attachments-header">
  <div class="d-flex align-items-center">
    <div class="me-2 d-flex align-items-center">
      <span class="material-symbols-outlined checklist-header-icon">playlist_add_check</span>
      <div>{{ T.common.checklist_attachments | translate }}</div>
    </div>
    <span class="checklist-attachments-count">({{ getTotalChecklistAttachmentsCount() }})</span>
  </div>
</div>

<div class="checklist-attachments-info">
  {{ T.common.checklist_attachments_info_msg | translate }}
</div>

<ng-container *ngIf="loading">
  <app-loading></app-loading>
</ng-container>

<ng-container *ngIf="!loading">
  <ng-container *ngIf="checklistAttachments.length > 0 && hasAnyAttachments">
    <div class="mt-2" *ngFor="let checklist of checklistAttachments; let i = index">
      <ng-container *ngIf="hasChecklistAttachments(checklist.checklistId)">
        <div class="attachments-container">
          <div class="mb-2 checklist-attachments-header d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="me-2 checklist-title">{{ checklist.checklistTitle ? checklist.checklistTitle : T.defaultLocalizations.checklist_item.additional | translate }}</div>
              <div class="individual-checklist-attachments-count">{{ getChecklistAttachmentsCount(checklist.checklistId) }} {{ T.common.attached | translate }}</div>
            </div>
            <div class="ms-auto" *ngIf="showViewChecklistButton">
              <app-button-transparent
                [iconFontSize]="12"
                [size]="'small'"
                [icon]="'arrow_forward_ios'"
                [reverseIconPlacement]="true"
                [text]="T.settings.view_checklist | translate"
                (clicked)="onViewChecklist(checklist)"
              ></app-button-transparent>
            </div>
          </div>
          <app-attachments-board-view
            (onAttachmentDownload)="attachmentDownload($event)"
            (onAttachmentDelete)="deleteDocument($event)"
            (onAttachmentLinkClicked)="attachmentLinkClicked($event)"
            [documents]="getAllChecklistDocuments(checklist.checklistId)"
            [accountId]="accountId"
            [documentContextualInfoMapping]="getDocumentContextualInfoMapping(checklist.checklistId)">
          </app-attachments-board-view>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="checklistAttachments.length === 0 || !hasAnyAttachments">
    <div class="empty-attachments-container">
      <div class="text-center text-muted mt-3">
        <div class="mb-1 empty-state-header">{{ T.common.no_checklist_attachments | translate }}</div>
        <p class="empty-state-subtext">{{ T.common.add_checklist_attachments_info | translate }}</p>
      </div>
    </div>
  </ng-container>
</ng-container>
